import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    portfolios: [],
    selectedPortfolio: null,
    isLoading: false
};

const portfolioSlice = createSlice({
    name: "portfolio",
    initialState,
    reducers: {
        setPortfolios: (state, action) => {
            state.portfolios = action.payload;
        },
        setSelectedPortfolio: (state, action) => {
            state.selectedPortfolio = action.payload;
        },
        addPortfolio: (state, action) => {
            state.portfolios.unshift(action.payload);
        },
        updatePortfolio: (state, action) => {
            const index = state.portfolios.findIndex(
                p => p._id === action.payload._id
            );
            if (index !== -1) {
                state.portfolios[index] = action.payload;
            }
        },
        removePortfolio: (state, action) => {
            state.portfolios = state.portfolios.filter(
                p => p._id !== action.payload
            );
        }
    }
});

export const {
    setPortfolios,
    setSelectedPortfolio,
    addPortfolio,
    updatePortfolio,
    removePortfolio
} = portfolioSlice.actions;

export const PortfolioReducer = portfolioSlice.reducer;
